(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
    return;
  }
  if (root.MNGiveawayCTA) {
    root.MNGiveawayCTA.refresh();
    return;
  }
  var api = factory();
  var document = root.document;
  var timer;

  function readConfig() {
    var node = document.getElementById('mn-giveaway-config');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (_) { return {}; }
  }

  function writeText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function shelfFor(announcement) {
    var section = announcement.closest('.shopify-section');
    var sibling = section && section.nextElementSibling;
    while (sibling) {
      if (sibling.matches('.section--featured-collection')) return sibling;
      if (sibling.matches('.mn-giveaway-cta-section')) return null;
      sibling = sibling.nextElementSibling;
    }
    return null;
  }

  function refresh() {
    root.clearTimeout(timer);
    var announcements = document.querySelectorAll('[data-mn-giveaway-cta]');
    var previousShelves = document.querySelectorAll('[data-mn-cta-categories]');
    if (!announcements.length) {
      previousShelves.forEach(function (shelf) { shelf.removeAttribute('data-mn-cta-categories'); });
      return;
    }
    var currentShelves = [];
    var now = Date.now();
    var config = readConfig();
    var campaign = api.campaignState(config, now, root.MNGiveawayMath);
    announcements.forEach(function (announcement) {
      var current = api.campaignState(config, now, root.MNGiveawayMath,
        announcement.dataset.liveBeforeLaunch === 'true');
      announcement.dataset.campaignState = current.status;
      writeText(announcement.querySelector('[data-mn-cta-label]'), current.label);
      writeText(announcement.querySelector('[data-mn-cta-heading]'), current.status === 'ended'
        ? 'Entries are closed.' : announcement.dataset.heading);
      var rate = announcement.querySelector('[data-mn-cta-rate]');
      if (rate) rate.hidden = !current.showRate;
      var displayRate = Math.round(current.rate * 5 * 1e8) / 1e8;
      var rateText = api.formatRate(displayRate);
      writeText(announcement.querySelector('[data-mn-cta-entry-text]'), rateText + (displayRate === 1 ? ' entry' : ' entries'));
      var caption = current.status === 'ended' ? 'Thank you for entering the giveaway.'
        : current.status === 'paused' ? 'Giveaway entry earning is paused.'
        : 'Every $5 of eligible spending during the giveaway earns ' + (displayRate === 1 ? 'one entry.' : rateText + ' entries.');
      writeText(announcement.querySelector('[data-mn-cta-caption]'), caption);
      var shopLink = announcement.querySelector('[data-mn-cta-shop]');
      writeText(shopLink, current.status === 'live' ? 'Shop to earn entries' : 'Browse merch');
      var shelf = shelfFor(announcement);
      if (shelf && shelf.id) {
        currentShelves.push(shelf);
        shelf.setAttribute('data-mn-cta-categories', '');
        if (shopLink) shopLink.setAttribute('href', '#' + shelf.id);
      }
    });
    previousShelves.forEach(function (shelf) {
      if (currentShelves.indexOf(shelf) === -1) shelf.removeAttribute('data-mn-cta-categories');
    });
    timer = root.setTimeout(refresh, api.nextRefresh(config, now, campaign));
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('[data-mn-cta-shop]');
    if (!link) return;
    var announcement = link.closest('[data-mn-giveaway-cta]');
    var shelf = announcement && shelfFor(announcement);
    if (!shelf) return;
    event.preventDefault();
    var reducedMotion = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    shelf.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    var target = shelf.querySelector('.tabs-product-header__item.--active') || shelf.querySelector('.tabs-product-header__item');
    if (target) target.focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-mn-giveaway-cta]').forEach(function (announcement) {
      var shelf = shelfFor(announcement);
      if (shelf) shelf.removeAttribute('data-mn-cta-categories');
    });
    root.clearTimeout(timer);
    timer = root.setTimeout(refresh, 0);
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  root.addEventListener('pageshow', refresh);
  root.MNGiveawayCTA = Object.freeze({ refresh: refresh });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var FALLBACK_START = '2026-09-21T18:00:00-04:00';
  var FALLBACK_END = '2026-11-20T23:59:59-05:00';

  function timestamp(value) {
    if (typeof value !== 'string') return NaN;
    var trimmed = value.trim();
    var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?(Z|([+-])(\d{2}):(\d{2}))$/.exec(trimmed);
    if (!match) return NaN;
    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    var second = Number(match[6] || 0);
    var offsetHour = Number(match[10] || 0);
    var offsetMinute = Number(match[11] || 0);
    var local = new Date(0);
    local.setUTCFullYear(year, month - 1, day);
    local.setUTCHours(hour, minute, second, 0);
    if (year < 1 || month < 1 || month > 12 || day < 1 || local.getUTCDate() !== day || hour > 23 || minute > 59 || second > 59 || offsetHour > 14 || offsetMinute > 59 || (offsetHour === 14 && offsetMinute > 0)) return NaN;
    return Date.parse(trimmed);
  }

  function campaignDate(value, fallback) {
    return timestamp(value === undefined || value === null || value === '' ? fallback : value);
  }

  function campaignState(config, now, math, showLiveBeforeLaunch) {
    config = config || {};
    var start = campaignDate(config.startsAt, FALLBACK_START);
    var end = campaignDate(config.endsAt, FALLBACK_END);
    var result = { status: 'paused', label: 'Giveaway Paused', rate: 0, showRate: false, startsAt: start, endsAt: end };
    if (config.enabled !== true || !Number.isFinite(now) || !Number.isFinite(start) || !Number.isFinite(end) || start >= end) return result;
    if (now > end) {
      result.status = 'ended';
      result.label = 'Giveaway Ended';
      return result;
    }
    if (!math || typeof math.state !== 'function') {
      if (now < start) {
        result.status = 'upcoming';
        result.label = 'Giveaway Coming Soon';
      }
      return result;
    }
    var rateState = math.state(config, now);
    if (!rateState.enabled || !Number.isFinite(rateState.rate) || rateState.rate <= 0) return result;
    result.status = now < start && showLiveBeforeLaunch !== true ? 'upcoming' : 'live';
    result.label = result.status === 'live' ? 'Giveaway Live' : 'Giveaway Coming Soon';
    var multiplier = now >= start && rateState.multiplierActive === true ? rateState.multiplier : 1;
    result.rate = rateState.rate * multiplier;
    if (!Number.isFinite(result.rate) || result.rate <= 0) return Object.assign(result, { status: 'paused', label: 'Giveaway Paused', rate: 0 });
    result.showRate = true;
    return result;
  }

  function nextRefresh(config, now, state) {
    var boundaries = [state.startsAt, state.endsAt + 1, timestamp(config.multiplierStartsAt), timestamp(config.multiplierEndsAt)];
    var wait = 60000;
    boundaries.forEach(function (boundary) {
      if (Number.isFinite(boundary) && boundary > now) wait = Math.min(wait, boundary - now);
    });
    return Math.max(20, wait);
  }

  function formatRate(value) {
    return Number.isFinite(value) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(value) : '0';
  }

  return Object.freeze({ campaignState: campaignState, nextRefresh: nextRefresh, formatRate: formatRate });
});
